import React from 'react';
import { ChatAvatar } from '@/components/whatsapp2/chat/ChatAvatar';
import { useProfilePicture } from '@/lib/hooks/whatsapp/useProfilePicture';

interface ConversationAvatarProps {
  name: string;
  imageUrl?: string | null;
  isGroup?: boolean;
  /** JID della chat WhatsApp: la foto si carica in modo pigro da WAHA quando la riga e' visibile. */
  whatsappChatId?: string;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Avatar unico per tutte le liste del drawer Messaggi: riusa `ChatAvatar` di
 * WhatsApp (iniziali di ripiego, indicatore gruppo) e, per le chat WhatsApp,
 * il caricamento pigro della foto profilo da WAHA (stesso hook della lista
 * WhatsApp: cache globale, massimo 3 richieste in parallelo).
 */
export function ConversationAvatar({ name, imageUrl, isGroup = false, whatsappChatId, size = 'md' }: ConversationAvatarProps) {
  const { profilePicUrl, ref } = useProfilePicture(whatsappChatId);
  return (
    <div ref={ref} className="flex-shrink-0">
      <ChatAvatar name={name} imageUrl={imageUrl || profilePicUrl || undefined} isGroup={isGroup} size={size} />
    </div>
  );
}
